import { LegalEntityCountry } from '@seapoint/server/enums';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useData } from '../../../../contexts/data-context/use-data';
import { ErrorSection } from '../../../../design-system/error-section/error-section';
import { LoadingSection } from '../../../../design-system/loading/loading';
import { OpenAccountSection } from './components/open-account-section';

export const OpenAccountPage = () => {
  const { data, isLoading: isLoadingData, error: dataError } = useData();
  const { isDemoAccountsEnabled } = useFlags();

  if (isLoadingData) {
    return <LoadingSection text="Loading..." />;
  }

  if (!data) {
    return <ErrorSection error={dataError} />;
  }

  const demoDataConfig = isDemoAccountsEnabled
    ? {
        isEnabled: true as const,
        companyId: data?.companies[0].id,
      }
    : {
        isEnabled: false as const,
      };

  return (
    <OpenAccountSection
      isLegalEntityInUk={data.companies[0].legalEntity.country === LegalEntityCountry.GB}
      demoDataConfig={demoDataConfig}
    />
  );
};
